import { IntlShape } from 'react-intl';
import { getVics } from '../../api/documents/vics';
import { VicGridReadDTO } from '../../api/dto';
import { makeVicFilter } from '../../lib/filters/vic';
import { AsyncAutocompleteFormElement, TFormElement } from '../types';
import { UiSchemaType } from '../UiSchemaType';
import { documentTypeProperties } from './document';

interface VicSchemaParameters extends Pick<AsyncAutocompleteFormElement, 'path' | 'label' | 'required'> {
    multiple?: boolean;
}

export const vicSchema = ({ path, label, required, multiple }: VicSchemaParameters, intl: IntlShape): TFormElement => ({
    type: UiSchemaType.AUTOCOMPLETE_ASYNC,
    label,
    path,
    required,
    typeProperties: documentTypeProperties({
        fetchOptions: async (query) => {
            const result = await getVics({ filter: makeVicFilter(query) });
            return result.content;
        },
        getOptionLabel: (vic: VicGridReadDTO) => intl.formatMessage({ id: 'vic.titleExisting' }, { id: vic.id }),
        label: intl.formatMessage({ id: 'vic.name' }),
        multiple,
        autocompletePropsOverrides: {
            disableCloseOnSelect: true,
        },
    }),
});
